//import model from '../model.json'

class Session
{
    constructor()
    {
        this.language = 'en';
        //this.model = model[this.language]
        this.model = undefined;
        //this.model.destinations = destinations[this.language]
    }

    async setLanguage(lang)
    {
        this.language = lang;
        this.model = await (await fetch(`/model/model_${lang}.json`)).json();
        //this.model = await this.model.json();
        return this.model;
        //this.model = model[this.language];
        //this.model.destinations = destinations[this.language]
    }
    
    getBannerPictures(name)
    {
        try{
            // console.log(this.model.data.banners);
            // console.log(name);
            return this.model.data.banners.filter( b => b.name === name)[0].pics.map( i => `${i.pic}` )
        } catch(ex)
        {
            return undefined;
        }
    }
}

export default new Session();